import { AutoRotatingCarousel, Slide } from "material-auto-rotating-carousel";
import { red, blue, green, yellow } from "@material-ui/core/colors";
const CarouselModel = ({ handleOpen, setHandleOpen, isMobile }) => {
  return (
    <>
      <AutoRotatingCarousel
        label="Get started"
        open={handleOpen.open}
        onClose={() => setHandleOpen({ open: false })}
        onStart={() => setHandleOpen({ open: false })}
        autoplay={false}
        mobile={isMobile}
        style={{ position: "absolute" }}
      >
        <Slide
          media={<img src="./photo1.png" alt="photo1" />}
          mediaBackgroundStyle={{ backgroundColor: red[400] }}
          style={{ backgroundColor: red[600] }}
          title="Latest News"
          subtitle="Press the Mic Icon And Say: Give me the latest news"
        />
        <Slide
          media={<img src="./photo2.png" alt="photo2" />}
          mediaBackgroundStyle={{ backgroundColor: blue[400] }}
          style={{ backgroundColor: blue[600] }}
          title="News by Categories"
          subtitle="Press the Mic Icon And Say: Give me the latest technology news"
        />
        <Slide
          media={<img src="./photo3.png" alt="photo3" />}
          mediaBackgroundStyle={{ backgroundColor: green[400] }}
          style={{ backgroundColor: green[600] }}
          title="News by Terms"
          subtitle="Press the Mic Icon And Say: What's up with Playstation 5"
        />
        <Slide
          media={<img src="./photo4.png" alt="photo4" />}
          mediaBackgroundStyle={{ backgroundColor: blue[400] }}
          style={{ backgroundColor: blue[600] }}
          title="News by Terms"
          subtitle="Press the Mic Icon And Say: Tell me about Donald Trump"
        />
        <Slide
          media={<img src="./photo5.png" alt="photo5" />}
          mediaBackgroundStyle={{ backgroundColor: red[400] }}
          style={{ backgroundColor: red[600] }}
          title="News by Sources"
          subtitle="Press the Mic Icon And Say: Give me the news from CNN"
        />
        <Slide
          media={<img src="./photo6.png" alt="photo6" />}
          mediaBackgroundStyle={{ backgroundColor: yellow[600] }}
          style={{ backgroundColor: yellow[800] }}
          title="Opening An Article"
          subtitle="Press the Mic Icon And Say: Open Article Number 2"
        />
      </AutoRotatingCarousel>
    </>
  );
};

export default CarouselModel;
